// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1pW0V","col":"Table_col__3XHHT","fulfillmentStatus":"Table_fulfillmentStatus__2yHkf","emailCol":"Table_emailCol__140hB"};